import { TrainingClassTrainerSurveyURLArray } from '../../domain/training.class.trainer.surveyurl';

export class AddTrainingClassRequest {
    ClassName: string;
    ClassDuration: string;
    ProductIDs: number[];
    ClassCredits: number;
    LevelOrder: number;
    ClassTitle: string;
    PreviewText: string;
    ClassDescription: string;
    TrainerID: number;
    Explanation: string;
    IntroductoryVideoLabel: string;
    IntroductoryVideoURL: string;
    DimensionsGuideLabel: string;
    DimensionsGuideURL: string;
    TrainingDesignURL: string;
    FollowupSteps: string;
    APSPCertificate: boolean;
    FundamentalsClass: boolean;
    //
    EmailTemplateReminder: string;
    EmailTemplateNoShows: string;
    EmailTemplateSetup: string;
    EmailTemplateCertificate: string;
    EmailTemplateRegistrationConfirmation: string;
    EmailTemplateSelfCancel: string;
    //
    TrainingClassTrainerSurveyURLs: TrainingClassTrainerSurveyURLArray;
    //
    MinimumSoftwareVersionInt: number;
    MaximumSoftwareVersionInt: number;
    //
    OrderFormVisible: boolean;
    OrderFormDisplayName: string;
    OrderFormValue: number;
    OrderFormPrice: number;
}
